import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, startWith, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-cantidad-select',
  templateUrl: './cantidad-select.component.html',
  styleUrls: ['./cantidad-select.component.scss']
})
export class CantidadSelectComponent implements OnInit {
  public input = new FormControl('');
  @Input() public where: string = 'detalles';
  @Input() private cantidad = 1;
  @Input() public existencia: number;
  @Input() public loding = true;
  @Input() private isCedis: boolean;
  @Output() articuloReturn: EventEmitter<any> = new EventEmitter<any>();
  private unsubscribe$ = new Subject<void>();

  constructor() { }

  ngOnInit(): void {
    this.switchType();
    this.valueChanges();

  }

  ngOnChanges(): void {
    this.switchType();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private switchType = () => {
    // console.log(this.where);
    switch (this.where) {
      case 'detalles':
        this.setValue(this.existencia > 0 ? '1' : 0);
        this.articuloReturn.emit({ cantidad: Number(this.getValue()), cedis: this.isCedis });
        break;
      case 'cart':
        this.setValue(this.cantidad);
        break;
      case 'list-product':
        this.setValue(this.existencia > 0 ? 0 : 0);
        break;
    }
  }

  private valueChanges = () => {
    switch (this.where) {
      case 'detalles':
        this.input.valueChanges.pipe(debounceTime(200), takeUntil(this.unsubscribe$)).subscribe(value => {
          if (Number(value) > Number(this.existencia)) {
            this.setValue(Number(this.existencia));
          } else if (Number(value) <= 0 && this.existencia > 0) {
            this.setValue(1);
          }
          this.articuloReturn.emit({ cantidad: value, cedis: this.isCedis });
        });
        break;
      case 'cart':
        this.input.valueChanges.pipe(debounceTime(250),
          takeUntil(this.unsubscribe$))
          .subscribe(value => {
            if (Number(value) > Number(this.existencia)) {
              this.setValue(Number(this.existencia));
            } else if (Number(value) <= 0 && this.existencia > 0) {
              this.setValue(1);
            }
            this.articuloReturn.emit({ cantidad: value, cedis: this.isCedis });
          });
        break;
      case 'list-product':
        // console.log('valueChanges ');
        this.input.valueChanges.pipe(startWith(0), debounceTime(200), takeUntil(this.unsubscribe$)).subscribe((value) => {
          if (Number(value) > Number(this.existencia)) {
            console.log('linea 84', this.existencia);
            this.setValue(Number(this.existencia));
          }
          if (value > 0) {
            // console.log('linea 88',this.existencia);
            this.articuloReturn.emit({ cantidad: value, cedis: this.isCedis });
          }
        });
        break;
    }
  }

  public getValue = (): string => {
    return this.input.value;
  }

  public getValueNumber = (): number => {
    return Number(this.input.value);
  }

  public setValue = (value): void => {
    this.input.setValue(value);
  }

  quantityUp = () => {
    const existencia = this.existencia;
    const cantidadCast = Number(this.getValue());
    const cantidad = Number(this.getValue()) + (existencia > cantidadCast ? 1 : 0);
    this.setValue(cantidad);
  }

  quantityDown = () => {
    const cantidadCast = Number(this.getValue());
    const cantidad = cantidadCast - (cantidadCast > 1 ? 1 : 0);
    this.setValue(cantidad);
  }
}
